import { FC } from 'react';
import {
  Item,
  StyledListItem,
  StyledListItemText,
} from 'containers/AppContainer/SideBar/style';
import { List, ListItemIcon } from '@material-ui/core';
import HomeIcon from 'components/SahamIcons/HomeIcon';
import { translate } from 'containers/services/translate';
import messages from 'containers/AppContainer/messages';
import { history } from 'store';
import { PAGES } from 'routes';
import { IntlShape, injectIntl } from 'react-intl';
import FeeNoteIcon from 'components/SahamIcons/FeeNoteIcon';
import NewSinisterIcon from 'components/SahamIcons/NewSinistersIcon';
import ProcessedDossiers from 'components/SahamIcons/ProcessedDossiers';

const selectedItem = (paths: string[]) => {
  return paths.some(path => path === history.location.pathname);
};

export interface ExpertMenuProps {
  intl: IntlShape;
  isManager?: boolean;
  pushToAndReset: Function;
  isMenuOpen: boolean;
}

const ExpertMenu: FC<ExpertMenuProps> = (props): JSX.Element => {
  const { pushToAndReset, isMenuOpen } = props;
  return (
    <List>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.EXPERT_HOME])}
          onClick={pushToAndReset(PAGES.EXPERT_HOME)}
        >
          <ListItemIcon>
            <HomeIcon isActivated />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.sideBarHomeTitle, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.EXPERT_ASSIGNED_MISSIONS])}
          onClick={pushToAndReset(PAGES.EXPERT_ASSIGNED_MISSIONS)}
        >
          <ListItemIcon>
            <NewSinisterIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.assignedDossiers, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>

      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.EXPERT_COMPLETED_MISSIONS])}
          onClick={pushToAndReset(PAGES.EXPERT_COMPLETED_MISSIONS)}
        >
          <ListItemIcon>
            <ProcessedDossiers />
          </ListItemIcon>
          {isMenuOpen && (
            <StyledListItemText open={isMenuOpen}>
              <span className="menuItemText">
                {translate(messages.processedDossiers, props)}
              </span>
            </StyledListItemText>
          )}
        </StyledListItem>
      </Item>
      <Item>
        <StyledListItem
          open={isMenuOpen}
          button
          selected={selectedItem([PAGES.EXPERT_FEE_NOTE])}
          onClick={pushToAndReset(PAGES.EXPERT_FEE_NOTE)}
        >
          <ListItemIcon>
            <FeeNoteIcon />
          </ListItemIcon>
          {isMenuOpen && (
            <>
              <StyledListItemText open={isMenuOpen}>
                <span className="menuItemText">
                  {translate(messages.sideBarFeeNote, props)}
                </span>
              </StyledListItemText>
            </>
          )}
        </StyledListItem>
      </Item>
    </List>
  );
};

export default injectIntl(ExpertMenu);
